import {
    brushStrokeToPathD,
    strokesForRender,
    type BrushStroke,
} from "../../utils/artbrushStroke";

export function ArtbrushStrokeLayer({
    strokes,
    activeStroke,
}: {
    strokes: BrushStroke[];
    activeStroke: BrushStroke[] | null;
}) {
    const all = strokesForRender(strokes, activeStroke);
    return (
        <g className="artbrush-svg-canvas__strokes">
            {all.map((stroke) => {
                const d = brushStrokeToPathD(stroke);
                if (!d) return null;
                return (
                    <path
                        key={stroke.id}
                        d={d}
                        fill={stroke.color}
                        stroke="none"
                    />
                );
            })}
        </g>
    );
}
